import React from 'react'
import Text from '../components/Text.js'

import { breakpoints } from '../constants/theme'
const { min1920, min1440, min1024, min768, min480 } = breakpoints

export default props => (
  <Text
    tag='h5'
    {...props}
    bold
    size={20}
    sizes={{[min768]: 20, [min1024]: 22,[min1920]:26}}
    height={28}
      heights={{[min768]: 30, [min1024]: 32, [min1920]: 36}}/>
)



// WEBPACK FOOTER //
// ../styleguide/Heading5.js